import { Box, Typography } from "@mui/material";
import { blueGrey, grey } from "@mui/material/colors";
import React from "react";

interface Props {
  title: string;
  date?: string;
  badg?: string;
  status?: 0 | 1 | 2;
}

export default function StartStep({ title, badg, date, status }: Props) {
  return (
    <Box
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "0px",
          right: "14px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          noWrap
          sx={{
            fontSize: "12px",
            color: blueGrey[400],
          }}
          color={
            status === 0
              ? "info.main"
              : status === 1
              ? "secondary.main"
              : "success.main"
          }
        >
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: "12px",
            fontFamily: "YekanBakh",
          }}
        >
          {date}
        </Typography>

        {badg?.length && (
          <Typography
            noWrap
            sx={{
              padding: "4px",
              backgroundColor: "success.light",
              textAlign: "center",
              color: "success.main",
              fontSize: "10px",
              fontWeight: "700",
              borderRadius: "4px",
            }}
          >
            {badg}
          </Typography>
        )}
      </Box>
      <Box
        sx={{
          width: "12px",
          height: "12px",
          borderRadius: "50%",
          backgroundColor:
            status === 0
              ? grey[300]
              : status === 1
              ? "secondary.main"
              : "success.main",
        }}
      ></Box>
      <Box
        sx={{
          width: "2px",
          backgroundColor:
            status === 0
              ? grey[300]
              : status === 1
              ? "secondary.main"
              : "success.main",
          height: "30px",
        }}
      ></Box>
    </Box>
  );
}
